var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrashFullCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3611_2970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8889 16.6826H4.11111C3.252 16.6826 2.55556 15.9663 2.55556 15.0826V4.68262H1.8C1.35817 4.68262 1 4.32444 1 3.88262C1 3.44079 1.35817 3.08262 1.8 3.08262H4.11111V2.28262C4.11111 1.39896 4.80756 0.682617 5.66667 0.682617H10.3333C11.1924 0.682617 11.8889 1.39896 11.8889 2.28262V3.08262H14.2C14.6418 3.08262 15 3.44079 15 3.88262C15 4.32444 14.6418 4.68262 14.2 4.68262H13.4444V15.0826C13.4444 15.9663 12.748 16.6826 11.8889 16.6826ZM4.11111 4.68262V15.0826H11.8889V4.68262H4.11111ZM5.66667 2.28262V3.08262H10.3333V2.28262H5.66667ZM10.3333 12.7048C10.3333 13.1344 9.98511 13.4826 9.55556 13.4826C9.126 13.4826 8.77778 13.1344 8.77778 12.7048V7.0604C8.77778 6.63084 9.126 6.28262 9.55556 6.28262C9.98511 6.28262 10.3333 6.63084 10.3333 7.06039V12.7048ZM7.22222 12.7048C7.22222 13.1344 6.874 13.4826 6.44444 13.4826C6.01489 13.4826 5.66667 13.1344 5.66667 12.7048V7.0604C5.66667 6.63084 6.01489 6.28262 6.44444 6.28262C6.874 6.28262 7.22222 6.63084 7.22222 7.06039V12.7048Z",
    fill: "#5B6673"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3611_2970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.682617)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashFullCartIcon);
export default __webpack_public_path__ + "static/media/trash-full-cart-icon.d0933e099075752005b1aa1715e45c7a.svg";
export { ForwardRef as ReactComponent };